import { Box, useTheme } from "@mui/material";
import * as React from "react";
import { Link } from "react-router";

import { UIUploadItem } from "@/providers/FileTransfer/types";
import { Goto } from "@/shared/navigation";

interface LinkableRowProps {
  children: React.ReactNode;
  isHovering: boolean;
  item: UIUploadItem;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const LinkableRow: React.FC<LinkableRowProps> = ({
  children,
  isHovering,
  item,
  onMouseEnter,
  onMouseLeave,
}) => {
  const theme = useTheme();

  // Opens the dataset's file browser at the folder the file or folder was uploaded into.
  const folder = [item.prefix, ...item.relative_path.split("/").slice(0, -1)]
    .filter((segment) => segment)
    .join("/");
  const linkAddr = Goto.createDatasetRoute(item.dataset_id, folder);

  const isLinkDisplayed = isHovering && item.isUploadCompleted;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(1.5),
        "&:hover": {
          backgroundColor: theme.palette.background.default,
        },
        width: "100%",
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {isLinkDisplayed ? (
        <Link
          to={linkAddr}
          style={{
            textDecoration: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
            width: "100%",
          }}
        >
          {children}
        </Link>
      ) : (
        children
      )}
    </Box>
  );
};
